import React, { useMemo } from 'react'

import { TMetricWithConfig } from 'types/GlobalMetric'

import Chip from 'components_new/atoms/Chip'

import ContentBox from 'components_new/molecules/ContentBox'
import FormSection from 'components_new/molecules/FormSection'
import InputTable, { InputTableRow } from 'components_new/molecules/InputTable'

import { useMetricActions } from 'redux/actions/Metrics'
import { sortAlphabeticalAsc } from 'utils/sortHelper'
import { useTranslation } from 'language/translator'

interface ConfigSectionProps {
  metric: TMetricWithConfig
}

const parseNumber = (value: string) =>
  value === '' ? null : parseFloat(value.replace(',', '.').replace(/\s/g, ''))

const ConfigSection = (props: ConfigSectionProps) => {
  const { metric } = props

  const { tryPutConfigValue } = useMetricActions()
  const { t } = useTranslation()

  const handleChange = (row: InputTableRow, value: string) => {
    const parsedValue = parseNumber(value)

    tryPutConfigValue(metric.id, {
      attribute_value: row.id,
      value: parsedValue
    })
  }

  const rows = useMemo(
    () =>
      [...metric.config.attribute_values]
        .sort((a, b) => sortAlphabeticalAsc(a.name, b.name))
        .map(
          (row): InputTableRow => ({
            id: row.id,
            title: row.name,
            input: {
              align: 'right',
              endAdornment: metric.config.unit,
              value: row.value?.toLocaleString('sv') ?? null
            }
          })
        ) || [],
    [metric.config.attribute_values]
  )

  return (
    <FormSection
      helperText={metric.config.description}
      importance="required"
      title={t('global', 'config')}
    >
      <ContentBox
        collapse={{ active: true, defaultCollapsed: true }}
        color="default"
        header={{
          title: metric.config.title,
          titleAdornment: <Chip label={rows.length} size="small" />
        }}
      >
        <InputTable edit={true} onChange={handleChange} rows={rows} />
      </ContentBox>
    </FormSection>
  )
}

export default ConfigSection
